import React from 'react';

export const LoadingComponent = () => {
  return (
    <div className="loading_container">
      <div className="loading_animation">
        <div className="wave" style={{animationDelay: '.5s'}}></div>
        <div className="wave" style={{animationDelay: '1s'}}></div>
        <div className="wave" style={{animationDelay: '1.5s'}}></div>
        <div className="wave" style={{animationDelay: '2s'}}></div>
        <div className="loading_text">Cargando...</div>
      </div>
    </div>
  );
};

